import styled from 'styled-components';

const AiCiTableWrapper = styled.div`
  margin-top: 8px;

  /* Header row: bottom rule only — no outer border framing. */
  .ant-table-thead > tr > th {
    padding-top: 0;
    border-bottom: solid 1px var(--line-gray);
  }

  .ant-table-thead > tr > th.ant-table-cell-fix-right,
  .ant-table-thead > tr > th.ant-table-cell-fix-right-first,
  .ant-table-thead > tr > th.ant-table-cell-fix-right-last {
    background-color: var(--white) !important;
  }

  .ant-table-tbody > tr > td {
    border-bottom: solid 1px var(--line-gray);

    &:first-child {
      border-left: solid 1px var(--line-gray);
    }
    &:last-child {
      border-right: solid 1px var(--line-gray);
    }
  }

  .ant-table-tbody > tr > td.ant-table-cell-fix-right,
  .ant-table-tbody > tr > td.ant-table-cell-fix-right-first,
  .ant-table-tbody > tr > td.ant-table-cell-fix-right-last {
    background-color: var(--white) !important;
  }

  /* Primary community row highlight. Use an opaque color so sticky cells do not show scrolled content underneath. */
  .ant-table-tbody > tr.primary,
  .ant-table-tbody > tr.primary > td.ant-table-cell-fix-right,
  .ant-table-tbody > tr.primary > td.ant-table-cell-fix-right-first,
  .ant-table-tbody > tr.primary > td.ant-table-cell-fix-right-last {
    background-color: var(--lavender-pale) !important;
  }

  .ant-table-tbody
    > tr:hover
    > td:not(.ant-table-cell-fix-right):not(.ant-table-cell-fix-right-first):not(.ant-table-cell-fix-right-last),
  .ant-table-tbody
    > tr
    > td.ant-table-cell-row-hover:not(.ant-table-cell-fix-right):not(.ant-table-cell-fix-right-first):not(
      .ant-table-cell-fix-right-last
    ) {
    background: transparent !important;
  }

  .ant-table-tbody > tr:hover > td.ant-table-cell-fix-right,
  .ant-table-tbody > tr:hover > td.ant-table-cell-fix-right-first,
  .ant-table-tbody > tr:hover > td.ant-table-cell-fix-right-last,
  .ant-table-tbody > tr > td.ant-table-cell-row-hover.ant-table-cell-fix-right,
  .ant-table-tbody > tr > td.ant-table-cell-row-hover.ant-table-cell-fix-right-first,
  .ant-table-tbody > tr > td.ant-table-cell-row-hover.ant-table-cell-fix-right-last {
    background-color: var(--white) !important;
  }

  .ant-table-tbody > tr.primary:hover > td.ant-table-cell-fix-right,
  .ant-table-tbody > tr.primary:hover > td.ant-table-cell-fix-right-first,
  .ant-table-tbody > tr.primary:hover > td.ant-table-cell-fix-right-last,
  .ant-table-tbody > tr.primary > td.ant-table-cell-row-hover.ant-table-cell-fix-right,
  .ant-table-tbody > tr.primary > td.ant-table-cell-row-hover.ant-table-cell-fix-right-first,
  .ant-table-tbody > tr.primary > td.ant-table-cell-row-hover.ant-table-cell-fix-right-last {
    background-color: var(--lavender-pale) !important;
  }
`;

export const AiCiSection = styled.div`
  border-radius: 10px;
  border: solid 1px var(--line-gray);
  padding: 30px;
  background-color: #fff;
`;

export const AiCiSectionTitle = styled.div`
  font-size: 16px;
  font-family: var(--font-bold);
  margin-bottom: 16px;
`;

export const RankCell = styled.span`
  font-size: 14px;
  font-family: var(--font-bold);
  color: var(--text-primary);
`;

export const CommunityName = styled.div`
  max-width: 100%;
  min-width: 0;
  font-size: 14px;
  font-family: var(--font-bold);
  color: var(--text-primary);
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
`;

export const CommunitySubtitle = styled.div`
  font-size: 12px;
  font-family: var(--font-regular);
  color: var(--text-secondary);
  margin-top: 2px;

  &.primary {
    color: var(--competitor-purple);
  }
`;

export default AiCiTableWrapper;
